import { InjectionToken, NgModule } from '@angular/core';
import { XSi18nService } from '@nx-fe/services';
import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { EnrollPageComponent } from './components/enroll-page/enroll-page.component';

export const dmaUrl = new InjectionToken<string>('');

@NgModule({
  declarations: [
    EnrollPageComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    TranslateModule,
    BrowserModule,
  ],
  providers: [
    XSi18nService,
    XsI18nPipe,
    // { provide: dmaUrl, useValue: '/XSight/' }
  ],
  bootstrap: []
})
export class EnrollModule {
}
